import { ParagraphComponent } from '../components/paragraph/paragraph.component';

export const COMPONENTS_MAPPER = {
  [ParagraphComponent.kind]: {
    component: ParagraphComponent,
    display: 'Párrafo',
  },
};
